import React from 'react';
import TestimonialCard from './TestimonialCard';

// Main Testimonials Component
const Testimonials = () => {
  // Testimonial data array for reuse
  const testimonialData = [
    {
      imageFileName: 'dog_1.png',
      quote: '“Mr Delivery Man dropped off this kibble a couple weeks ago. All I can say is it gets a two paws up from me!”',
      author: 'Ralph',
      location: 'Auckland'
    },
    {
      imageFileName: 'dog_2.png',
      quote: '“Grain free, high protein and eco friendly!! It doesn’t get much better than that!”',
      author: 'Elsa',
      location: 'Dunedin'
    },
    {
      imageFileName: 'dog_3.png',
      quote: '“Not only does the food just smell amazing, it is made using a natural recipe with chicken.”',
      author: 'Nadira',
      location: 'Wellington'
    },
  ];

  return (
    <div className="testimonial-wrapper">
      <div className="container-fluid">
        <h2 className="text-center sc-lg">
          Loved by Thousands of New Zealand <span className="slash-or">Furbabies</span>
        </h2>
        <h2 className="text-center sc-sm">
          Loved by Thousands of <br /> New Zealand <span className="slash-or">Furbabies</span>
        </h2>
        <div className="card-wrapper def-w-max">
          <div className="row">
            {/* Mapping through testimonialData array to generate each card */}
            {testimonialData.map((testimonial, index) => (
              <div className="col-12 col-sm-6 col-md-4" key={index}>
                <TestimonialCard {...testimonial} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
